import React, { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../magic_forms_2/store/hooks";
import {
  getAsesorBrandConfig,
  getAsesorInfo,
  getAsesorPic,
  selectAsesor,
  selectAsesorPic,
  selectAsesorPicLoading,
  selectBrandConfig,
  selectLoadingAsesor,
  selectLoadingBrandConfig,
} from "./asesorSlice";
import { ReactComponent as Contact } from "../assets/contact.svg";
import { ReactComponent as Phone } from "../assets/phone.svg";
import { ReactComponent as Place } from "../assets/place.svg";
import { ReactComponent as Mail } from "../assets/email.svg";
import useQuery from "../utils/UseQuery";
import ClipLoader from "react-spinners/ClipLoader";
import { ShowData } from "./components/ShowData";
import { ServiceSelectComponent } from "./components/ServiceSelectComponent";

export const AsesorCardDetail = () => {
  const asesor = useAppSelector(selectAsesor);
  const brandConfig = useAppSelector(selectBrandConfig);
  const loadingInfo = useAppSelector(selectLoadingAsesor);
  const loadingPic = useAppSelector(selectAsesorPicLoading);
  const loadingBrandConfig = useAppSelector(selectLoadingBrandConfig);
  const picBase64 = useAppSelector(selectAsesorPic);

  const dispatch = useAppDispatch();

  const query = useQuery();
  const idAsesor = query.get("idAsesor") ?? "error";

  const infoRender = () => {
    let asesorDataSorted = [...(asesor.asesorData.fieldsToShow || [])];
    asesorDataSorted = asesorDataSorted?.sort((a, b) => {
      return a.showingOrder - b.showingOrder;
    });
    asesorDataSorted = asesorDataSorted?.slice(0, 4);
    if (asesorDataSorted && asesorDataSorted.length > 0) {
      return (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "start",
          }}
        >
          {asesorDataSorted.map((field) => {
            return (
              <ShowData
                label={field.label || "Elemento"}
                value={field.value!}
                primaryColor={brandConfig.primaryTextColor!}
                iconId={field.iconId}
                key={field.id!}
                phonePrefix={field.phonePrefix}
                small
              />
            );
          })}
        </div>
      );
    } else {
      return (
        <>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "start",
            }}
          >
            {asesor.name && (
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "center",
                  alignItems: "center",
                  margin: "21px 0 21px 0",
                }}
              >
                <Contact
                  color={brandConfig.primaryTextColor}
                  width={30}
                  height={30}
                />
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "start",
                    margin: "0 0 0 18px",
                  }}
                >
                  {" "}
                  <p
                    style={{
                      fontSize: "15px",
                      fontWeight: 600,
                      color: brandConfig.primaryTextColor,
                      textTransform: "uppercase",
                      margin: 0,
                    }}
                  >
                    {asesor.name}
                  </p>{" "}
                  <p
                    style={{
                      fontSize: "15px",
                      fontWeight: 600,
                      color: brandConfig.primaryTextColor,
                      textTransform: "uppercase",
                      margin: 0,
                    }}
                  >
                    {asesor.identification}
                  </p>
                </div>
              </div>
            )}
            {asesor.phoneNumber && (
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "center",
                  alignItems: "center",
                  margin: "0 0 18px 0",
                }}
              >
                <Phone
                  color={brandConfig.primaryTextColor}
                  width={30}
                  height={25}
                />
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "start",
                    margin: "0 0 0 18px",
                  }}
                >
                  <p
                    style={{
                      fontSize: "15px",
                      fontWeight: 600,
                      color: brandConfig.primaryTextColor,
                      textTransform: "uppercase",
                      margin: 0,
                    }}
                  >
                    <a
                      style={{ color: "inherit", textDecoration: "none" }}
                      href={`tel:+57${asesor.phoneNumber}`}
                    >
                      {asesor.phoneNumber}
                    </a>
                  </p>{" "}
                </div>
              </div>
            )}
            {asesor.email && (
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "center",
                  alignItems: "center",
                  margin: "0 0 21px -2px",
                }}
              >
                <Mail
                  color={brandConfig.primaryTextColor}
                  width={25}
                  height={25}
                  style={{ marginLeft: "3px" }}
                />
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "start",
                    margin: "0 0 0 18px",
                  }}
                >
                  <p
                    style={{
                      fontSize: "15px",
                      fontWeight: 600,
                      color: brandConfig.primaryTextColor,
                      textTransform: "uppercase",
                      margin: 0,
                    }}
                  >
                    <a
                      style={{ color: "inherit", textDecoration: "none" }}
                      href={`mailto:${asesor.email}`}
                    >
                      {asesor.email}
                    </a>
                  </p>{" "}
                </div>
              </div>
            )}
            {asesor.asesorData.direccion && asesor.asesorData.oficina && (
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "center",
                  alignItems: "center",
                  margin: "0 0 21px 0",
                }}
              >
                <Place
                  style={{ margin: "0 0 0 -3px" }}
                  color={brandConfig.primaryTextColor}
                  width={30}
                  height={25}
                />
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "start",
                    margin: "0 0 0 18px",
                  }}
                >
                  {" "}
                  <p
                    style={{
                      fontSize: "15px",
                      fontWeight: 600,
                      color: brandConfig.primaryTextColor,
                      textTransform: "uppercase",
                      margin: 0,
                    }}
                  >
                    {asesor.asesorData.direccion}
                  </p>{" "}
                  <p
                    style={{
                      fontSize: "15px",
                      fontWeight: 600,
                      color: brandConfig.primaryTextColor,
                      textTransform: "uppercase",
                      margin: 0,
                    }}
                  >
                    Oficina {asesor.asesorData.oficina}
                  </p>
                </div>
              </div>
            )}
          </div>
        </>
      );
    }
  };

  const content = () => {
    if (loadingInfo === "pending" || loadingBrandConfig === "pending") {
      return (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            minHeight: "100vh",
            width: "100%",
          }}
        >
          <ClipLoader color={brandConfig.primaryTextColor} size={120} />;
          <h5
            style={{
              color: brandConfig.primaryTextColor,
              marginTop: "20px",
              fontSize: "20px",
            }}
          >
            Obteniendo información
          </h5>
        </div>
      );
    } else {
      return (
        <div
          style={{
            fontFamily: "Open Sans",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            width: "100%",
            minHeight: "100vh",
          }}
        >
          <img
            alt="Logo de la empresa"
            src={brandConfig.logoUrl!!}
            style={{
              maxWidth: "200px",
              maxHeight: "90px",
              width: "auto",
              height: "auto",
              margin: "8px 0 8px 0",
            }}
          />
          <div
            style={{
              display: "flex",
              alignItems: "start",
              flexDirection: "row",
              justifyContent: "space-evenly",
              marginBottom: "20px",
            }}
          >
            <div
              style={{
                maxWidth: "100px",
                maxHeight: "140px",
                margin: "0 0 0 0",
              }}
            >
              {loadingPic === "pending" ? (
                <ClipLoader color={brandConfig.primaryTextColor} size={40} />
              ) : (
                <img
                  alt="Imagen del asesor"
                  src={`data:image/png;base64, ${picBase64}`}
                  style={{
                    maxWidth: "100%",
                    maxHeight: "100%",
                    objectFit: "cover",
                    borderRadius: "30px",
                  }}
                />
              )}
            </div>
            {infoRender()}
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              width: "100%",
              margin: "10px 0 10px 0",
              padding: "0 5% 0 5%",
              boxSizing: "border-box",
            }}
          >
            <h6
              style={{
                fontSize: "15px",
                fontWeight: "500",
                color: brandConfig.primaryTextColor,
                textAlign: "start",
                margin: "0 0 10px 0",
              }}
            >
              A continuación encontrarás la lista de servicios que tenemos para
              tí
            </h6>
            {asesor.asesorData.hyperFlowConfigs &&
              asesor.asesorData.hyperFlowConfigs.map(
                (hyperFlowConfig, index) => {
                  return (
                    <ServiceSelectComponent
                      key={index}
                      title={hyperFlowConfig.title!}
                      description={hyperFlowConfig.description}
                      buttonText={hyperFlowConfig.buttonText}
                      primaryTextColor={brandConfig.primaryTextColor || "#fff"}
                      buttonColor={
                        brandConfig.primaryButtonColor ||
                        "linear-gradient(180deg, rgba(0, 0, 0, 0.5) 0%, rgba(0, 0, 0, 0.5) 100%)"
                      }
                      buttonTextColor={
                        brandConfig.primaryButtonTextColor ??
                        brandConfig.secondaryTextColor ??
                        "#fff"
                      }
                      hyperFlowId={hyperFlowConfig.hyperFlowId!}
                      idAsesor={idAsesor}
                    />
                  );
                }
              )}
          </div>
        </div>
      );
    }
  };

  useEffect(() => {
    if (loadingInfo === "idle" && idAsesor !== "error") {
      dispatch(getAsesorInfo(idAsesor));
    }

    if (loadingPic === "idle" && idAsesor !== "error") {
      dispatch(getAsesorPic(idAsesor));
    }

    if (loadingBrandConfig === "idle" && idAsesor !== "error") {
      dispatch(getAsesorBrandConfig(idAsesor));
    }
    return () => {};
  }, [idAsesor, dispatch, loadingInfo, loadingBrandConfig]);

  return (
    <div
      style={{
        minHeight: "100vh",
        width: "100%",
        display: "flex",
        justifyContent: "center",
        overflow: "auto",
        alignItems: "center",
        fontFamily: "Open Sans",
        background: `linear-gradient(180deg, ${brandConfig.backgroundColor1} , ${brandConfig.backgroundColor2})`,
      }}
    >
      {content()}
    </div>
  );
};
